<template lang="pug">
    div
        .loader-area
            v-progress-linear(
                indeterminate
                :class="{ 'hidden': !loading }"
                color="accent"
                )
        .container
            v-btn.mode-button(
                :color="modeButtonProps.color"
                @click="topButtonClick"
                dark
                :disabled="modeButtonProps.disabled || loading || (step === 2 && !selectedItems.length)"
                )
                span {{modeButtonProps.text}}
            v-text-field.search-field(
                :disabled="loading"
                v-model="searchText"
                v-bind="textFieldProps"
                @keydown.enter="currentAction"
                @keydown="validateKeydown"
                @blur="handleBlur"
                ref="field"
                )
            span.caption.status-message( 
                v-if="statusMessage"
                :class="statusMessage.classes"
                )
                | {{statusMessage.text}}
            .list-container(v-if="filteredResults && filteredResults.length")
                v-list
                    template(
                        v-for="(item, idx) in filteredResults"
                        )
                        v-list-tile(
                            :key="item.id"
                            @click="selectItem(item)"
                            avatar
                            )
                            v-list-tile-action
                                v-icon.green--text(
                                    :class="{hidden: !selectedItems.includes(item.id)}"
                                    )
                                    | check
                            v-list-tile-content
                                span {{item.name}}
                        v-divider
            span.grey--text(
                v-if="(!filteredResults || !filteredResults.length) && step === 2")
                | No se encontraron productos
            span.caption.results-text(
                v-if="step === 2"
                ) {{resultsText}}
            .d-flex(v-if="step === 2")
                v-chip
                    v-avatar.primary.white--text 
                        | {{selectedItems.length}}
                    span seleccionados
        // Snackbar
        v-snackbar(
        v-model="showSnackbar"
        :multi-line="snackMultiLine"
        :color="snackbarData.color"
        auto-height
        :timeout="0"
        )
            span(v-html="snackbarData.text")
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions, mapState } from 'vuex'
import CurrencyUtils from '../../mixins/CurrencyUtils'
import { cloneDeep } from 'lodash'

function initialState() {
    return {
        // Search
        completeMode: false,
        searchText: '',
        searchResults: [],
        filteredResults: [],
        selectedItems: [],
        singleSearch: null,

        // UI
        loading: false,
        step: 1,
        statusMessage: null,
        showSnackbar: false,
        snackbarData: {
            color: 'success',
            text: '',
        },
        snackMultiLine: false,
    }
}

export default {
    mixins: [CurrencyUtils],
    data: () => initialState(),
    computed: {
        singleStock() {
            if (
                this.singleSearch &&
                this.singleSearch.data &&
                this.singleSearch.data.data &&
                this.singleSearch.data.data.length
            )
                return this.getTotalBranchOfficeStock(
                    this.singleSearch.data.data[0]
                )
            return null
        },
        modeButtonProps() {
            if (this.step === 1) {
                if (this.completeMode)
                    return {
                        color: 'success',
                        text: 'BÚSQUEDA COMPLETA',
                    }
                return {
                    color: 'accent',
                    text: 'BÚSQUEDA EXACTA',
                }
            } else if (this.step === 2) {
                return {
                    action: () => {},
                    color: 'success',
                    text: 'Agregar al Carro',
                }
            } else if (this.step === 3) {
                return {
                    action: () => {},
                    color: 'success',
                    text: 'Agregar al Carro',
                    disabled: !('' + this.searchText).length,
                }
            }
            return {
                action: () => {},
                color: 'success',
                text: '',
            }
        },
        textFieldProps() {
            if (this.step === 2) return { label: 'Filtrar' }
            if (this.step === 3) return { label: 'Cantidad', type: 'number' }
            return {
                label: !this.completeMode
                    ? 'Buscar por Código Interno'
                    : 'Buscar por Nombre',
                'append-icon': this.loading ? '' : 'search',
                'append-icon-cb': this.loading ? () => '' : this.handleSearch,
            }
        },
        resultsText() {
            return `mostrando ${this.filteredResults.length} de ${this.searchResults.length} resultados`
        },
        ...mapGetters('AuthModule', {
            branchOfficeID: 'branchOfficeID',
        }),
        ...mapState('CartModule', {
            items: 'items',
        }),
    },
    methods: {
        handleBlur() {
            if (this.step === 3) {
                if (
                    ('' + this.searchText).length >
                    '' + ('' + this.singleStock).length
                )
                    return (this.searchText = this.singleStock)
                if (parseFloat(this.searchText) > this.singleStock)
                    return (this.searchText = this.singleStock)
                if (!this.searchText) this.searchText = 1
            }
        },
        validateKeydown(e) {
            if (this.step !== 3) return e
            else if (e.key === '.') {
                if (this.searchText.includes('.')) {
                    e.preventDefault()
                    return
                }
            } else if (isNaN(e.key) && e.key.length === 1) e.preventDefault()
        },
        topButtonClick() {
            if (this.step === 1) this.completeMode = !this.completeMode
            if (this.step === 2) this.addProductsToCart()
            if (this.step === 3) this.setQuantityAndAddToCart()
        },
        currentAction() {
            if (this.step === 1) {
                this.handleSearch()
            }
            if (this.step === 2) {
                //this.filter()
            }
            if (this.step === 3) {
                this.setQuantityAndAddToCart()
            }
        },
        setQuantityAndAddToCart() {
            let search = cloneDeep(this.singleSearch)
            try {
                search.data.data[0].quantity = parseFloat(this.searchText)
                this.setCart(search)
            } catch (e) {
                console.log(e)
            }
        },
        filter() {
            if (!this.searchText) this.filteredResults = this.searchResults
            this.filteredResults = this.searchResults.filter(i =>
                i.name.toUpperCase().includes(this.searchText.toUpperCase())
            )
        },
        getTimeoutPromise(ms = 10000) {
            return new Promise((resolve, reject) => {
                let id = setTimeout(() => {
                    clearTimeout(id)
                    reject({
                        response: {
                            data: { message: 'tiempo de espera agotado' },
                        },
                    })
                }, ms)
            })
        },
        handleSearch() {
            this.clearStatusMessage()
            if (!this.validateSearchText()) {
                this.loading = false
                return
            }
            this.loading = true
            this.slimGetProducts()
        },
        slimGetProducts() {
            return new Promise((resolve, reject) => {
                let route =
                    process.env.VUE_APP_API_ROUTE +
                    `/wh_product_slim_multiple_filter?search_string=${this.searchText}`
                if (!this.completeMode) {
                    route =
                        process.env.VUE_APP_API_ROUTE +
                        `/wh_product_slim_filter_alias_name?alias_name=${this.searchText}`
                }
                let timeout = this.getTimeoutPromise()
                let fetch = axios.get(route)
                Promise.race([fetch, timeout])
                    .then(this.slimResponseHandler)
                    .catch(this.errorHandler)
            })
        },
        slimResponseHandler(response) {
            if (
                !response.data ||
                !response.data.data ||
                !response.data.data.length
            ) {
                this.setErrorMessage('No se encontraron resultados')
                this.loading = false
                return
            }
            if (response.data.data.length === 1) {
                this.selectItem(response.data.data[0])
                this.addProductsToCart()
                return
            }
            this.searchResults = response.data.data.map(this.setOfficeData)
            this.filteredResults = this.searchResults
            this.step = 2
            this.searchText = ''
            this.loading = false
        },
        addProductsToCart() {
            this.loading = true
            let queryStr = this.selectedItems.join()
            let includes = `sl_wholesale_discounts,wh_product_upc_code`
            let appends = `sale_prices,stocks`
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/wh_product?filter[wh_product_ids]=${queryStr}&include=${includes}&append=${appends}&get_all_results=true`
            axios.get(route).then(this.checkQuantity)
        },
        getStockErrors(items) {
            const OFFICE =
                this.$store.getters['AuthModule/branchOfficeID'] || null
            return items.reduce((errors, i) => {
                let office = i.stocks.find(s => s.g_branch_office_id === OFFICE)
                if (
                    !office ||
                    !office.wh_warehouses ||
                    !office.wh_warehouses.length
                ) {
                    errors.push(i)
                    return errors
                }
                let total_branch_office_stock = office.wh_warehouses.reduce(
                    (stock, wh) => (stock += wh.logical_stock),
                    0
                )
                if (!total_branch_office_stock) {
                    errors.push(i)
                }
                return errors
            }, [])
        },
        getTotalBranchOfficeStock(i) {
            const OFFICE =
                this.$store.getters['AuthModule/branchOfficeID'] || null
            let office = i.stocks.find(s => s.g_branch_office_id === OFFICE)
            if (
                !office ||
                !office.wh_warehouses ||
                !office.wh_warehouses.length
            ) {
                throw i
            }
            return office.wh_warehouses.reduce(
                (stock, wh) => (stock += wh.logical_stock),
                0
            )
        },
        checkQuantity(response) {
            if (response.data.data.length === 1) {
                let stockErrors = this.getStockErrors(response.data.data)
                if (stockErrors && stockErrors.length) {
                    this.resetSearch()
                    return this.showStockErrorsSnackbar(stockErrors)
                }
                this.searchText = '1'
                this.singleSearch = response
                this.step = 3
                this.statusMessage = {
                    classes: {},
                    text: `Stock: ${this.singleStock}`,
                }
                this.loading = false
                this.$nextTick(() => this.$refs.field.focus())
                return
            }
            this.setCart(response)
        },
        showStockErrorsSnackbar(errors, isMulti = false) {
            this.snackbarData.color = 'error'
            this.snackbarData.text = `<p>Stock agotado para los siguientes productos:
                        <ul>
                        ${errors.reduce(
                            (list, product) =>
                                (list += `<li>
                                ${product.name}
                            </li>`),
                            ''
                        )}
                        </ul>
                        ${
                            isMulti
                                ? '<br>Los demás productos han sido agregados a la venta'
                                : ''
                        }
                    </p>`
            this.showSnackbar = true
            this.snackMultiLine = true
            setTimeout(this.clearSnackbar, 7000)
        },
        setCart(response) {
            // let items = [...this.items, ...response.data.data]
            let newItems = response.data.data
            let stockErrors = this.getStockErrors(newItems)
            newItems = newItems.filter(
                i => !stockErrors.map(itm => itm.id).includes(i.id)
            )
            let items = this.items.map(itm => {
                let idx = newItems.findIndex(el => el.id === itm.id)
                if (idx !== -1) {
                    itm.quantity++
                    newItems.splice(idx, 1)
                }
                return itm
            })
            if (stockErrors && stockErrors.length) {
                this.showStockErrorsSnackbar(
                    stockErrors,
                    newItems && newItems.length
                )
            } else {
                this.snackbarData.color = 'success'
                this.snackbarData.text = `Productos agregados exitosamente`
                this.showSnackbar = true
                this.snackMultiLine = true
                setTimeout(this.clearSnackbar, 7000)
            }
            this.loading = false
            if (!newItems || !newItems.length) return
            this.setCartItems([...items, ...newItems])
            this.resetSearch()
        },
        resetSearch() {
            let obj = initialState()
            //delete obj.statusMessage
            delete obj.showSnackbar
            delete obj.snackbarData
            delete obj.snackMultiLine
            Object.assign(this.$data, obj)
        },
        selectItem(item) {
            if (this.selectedItems.some(id => id === item.id)) {
                this.deselectItem(item)
            } else {
                this.selectedItems.push(item.id)
            }
        },
        deselectItem(item) {
            this.selectedItems = this.selectedItems.filter(id => id !== item.id)
        },
        errorHandler(err) {
            let message = 'Ha ocurrido un error'
            if (err.response) {
                if (err.response.error) message = err.response.eror
                if (err.response.data) {
                    if (err.response.data.error)
                        message = err.response.data.error
                    if (err.response.data.data && err.response.data.data.error)
                        message = err.response.data.data.error
                }
            }
            this.setErrorMessage(message)
            this.loading = false
        },
        validateSearchText() {
            const limit = this.completeMode ? 3 : 1
            if (this.searchText.length >= limit) return true
            this.setErrorMessage(
                `Deben ingresarse al menos ${limit} caractéres`
            )
            return false
        },
        setErrorMessage(message) {
            this.statusMessage = { classes: ['red--text'], text: message }
        },
        setSuccessMessage(message) {
            this.statusMessage = { classes: ['green--text'], text: message }
        },
        findStock(item) {
            if (!item) return 'ERR'
            if (!item.stocks) {
                return 'ERR. CONFIG'
            }
            if (!item.stocks || !item.stocks.length) return 'NO FIJADO'
            let stock = item.stocks
                .filter(st => st.g_branch_office_id === this.branchOfficeID)
                .reduce((sum, wh) => {
                    sum += wh.stock
                    return sum
                }, 0)
            if (isNaN(stock)) return 'ERR'
            stock = parseFloat(stock)
            return stock
        },
        clearSnackbar() {
            this.showSnackbar = false
            this.snackbarData = {
                color: 'success',
                text: '',
            }
        },
        findPrice(item) {
            if (!item.prices) return 'ERR. CONFIG'
            let price = item.prices.find(
                pr => pr.g_branch_office_id === this.branchOfficeID
            )
            return price &&
                (price.sale_price === 0 || price.sale_price) &&
                !isNaN(price.sale_price)
                ? parseInt(price.sale_price)
                : 'NO FIJADO'
        },
        setOfficeData(item) {
            let price = this.findPrice(item)
            let stock = this.findStock(item)
            item.sale_price = price
            item.stock = stock
            return item
        },
        clearStatusMessage() {
            this.statusMessage = null
        },
        ...mapActions('CartModule', {
            setCartItems: 'setCartItems',
        }),
    },
    watch: {
        searchText(v) {
            if (this.step === 2) this.filter()
            if (this.step === 3) {
                if (v.length > '' + this.singleStock.length)
                    return (this.searchText = this.singleStock)
                if (parseFloat(v) > this.singleStock)
                    return (this.searchText = this.singleStock)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.mode-button {
    position: absolute;
    top: 4px;
    right: 0px;
}
.loader-area {
    display: flex;
    justify-content: center;
    margin-top: -10px;
    overflow: hidden;
    height: 20px;
    width: 100vw;
    & .hide-bar {
        opacity: 0;
    }
}
.hidden {
    opacity: 0;
}
.search-field {
    margin-top: -10px;
}
.status-message {
    position: absolute;
    left: 18px;
    margin-top: -15px;
}
.list-container {
    //border: 1px solid grey;
    overflow: auto;
    height: calc(100vh - 210px);
}
.results-text {
    padding-left: 10px;
}
</style>
